/**
 * Created by Mark on 17/04/2017.
 */


import ApplicationServices from './base-service.js';
import Constants from '../constants.js';
import Action    from '../application-actions.js';

class SongsAndStoriesService {

    constructor(){

    }

    getAll(){

        return ApplicationServices.call(Constants.ALL_SONG_AND_STORIES_UPDATE , {}).then(function(response){
            Action.update(Constants.ALL_SONG_AND_STORIES_UPDATE , response.media);
        });

    }

}


export default new SongsAndStoriesService();